import { useTranslation } from "@opendash/i18n";
import { Card, Statistic } from "antd";
import { observer } from "mobx-react-lite";
import Parse from "parse";
import React, { useEffect, useState } from "react";
import { Ticket } from "../../../../../js/parsegenerated";

export const MyTickets = observer(() => {
  const t = useTranslation();
  const [myTickets, setMyTickets] = useState(0);

  useEffect(() => {
    new Parse.Query(Ticket)
      .equalTo("user", {
        __type: "Pointer",
        className: "_User",
        objectId: Parse.User.current().id,
      })
      .count()
      .then((count) => {
        setMyTickets(count);
      });
  }, []);

  return (
    //@ts-ignore
    <Card variant="outlined" style={{ width: "100%" }}>
      <Statistic
        title={t("maintenance:overview.statistics.mytickets.title")}
        value={myTickets}
      />
    </Card>
  );
});
